/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_LabelInputs */

const en_fc_tut_label = /** @type {(inputs: Fc_Tut_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic tutorial`)
};

/**
* | output |
* | --- |
* | "Basic tutorial" |
*
* @param {Fc_Tut_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_label = /** @type {((inputs?: Fc_Tut_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_label(inputs)
});
export { fc_tut_label as "fc.tut.label" }